module.exports = __webpack_public_path__ + "img/1523141618.a73a4709.jpg";